export default __webpack_public_path__ + "static/media/db.87ddba3f.jpg";